import { render, staticRenderFns } from "./AlternatingBlocks.vue?vue&type=template&id=458cf071&"
import script from "./AlternatingBlocks.vue?vue&type=script&lang=js&"
export * from "./AlternatingBlocks.vue?vue&type=script&lang=js&"
import style0 from "./AlternatingBlocks.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./AlternatingBlocks.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports